import type { ToolImage } from '../types/LabelingTypes';

/** Per-part image totals, as consumed by every part picker surface. */
export interface PartSummary {
  partId: string;
  imageCount: number;
  labeledCount: number;
}

/**
 * Groups a flat image list by the part (`toolId`) it belongs to.
 *
 * One entry per distinct `toolId`, in first-seen order: LabelingProvider sorts the images by
 * capture time on load, so parts come in the order they were machined.
 */
export function groupPartsFromItems(items: ToolImage[]): PartSummary[] {
  const parts = new Map<string, PartSummary>();

  for (const item of items) {
    const part = parts.get(item.toolId) ?? {
      partId: item.toolId,
      imageCount: 0,
      labeledCount: 0,
    };
    part.imageCount += 1;
    if (item.label !== null) part.labeledCount += 1;
    parts.set(item.toolId, part);
  }

  return Array.from(parts.values());
}
